export const siteConfig = {
  name: "Happykidz Preschool",
  legalName: "Happykidz Preschool & Kindergarten",
  tagline: "Where Little Minds Grow Big Dreams",
  phone: "+91 82491 56053",
  phoneRaw: "+918249156053",
  whatsapp: "+91 82491 56053",
  whatsappRaw: "918249156053",
  email: "info@happykidzpreschool.org",
  address: "Plot No. 84, Near Kharavela Park, Khandagiri, Bhubaneswar, Odisha - 751030",
  hours: "Monday to Saturday, 8:00 AM to 2:00 PM",
  hoursDetail: {
    weekdays: "8:00 AM – 2:00 PM",
    saturday: "8:00 AM – 12:00 PM",
    sunday: "Closed"
  },
  establishmentYear: 2008,
  
  // Links
  googleMapsEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.5!2d85.7939!3d20.2817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjDCsDE2JzU0LjEiTiA4NcKwNDcnMzguMCJF!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin",
  googleMapsDirections: "https://maps.google.com/?q=Plot+No+84,+near+Kharavela+Park,+Khandagiri,+Bhubaneswar",
  brochureUrl: "/assets/documents/brochure.pdf",
  virtualTourUrl: "", 
  paymentUrl: "https://pages.razorpay.com/happykidz-fees",
  googleReviewsUrl: "https://search.google.com/local/writereview?placeid=ChIJLf-0Zz1kPjoRwt9Vl_2wY_o",
  
  appLinks: {
    playStore: "",
    appStore: ""
  },
  
  // Social Media
  socials: {
    facebook: "https://facebook.com/happykidzschool",
    instagram: "https://instagram.com/happykidzschool",
    youtube: "https://youtube.com/happykidzschool",
    twitter: "https://twitter.com/happykidzschool"
  },
  
  // Verified Statistics
  stats: {
    yearsOfExcellence: "15+",
    happyStudents: "500+",
    qualifiedTeachers: "15+",
    learningPrograms: "4"
  }
};
